class SessionHelper {
  constructor() {
    this.TOKEN_KEY = 'token'
    this.ROLE_KEY = 'role'
    this.FULLNAME_KEY = 'fullName'
    this.MENU_KEY = 'menu'
    this.ROLES_KEY = 'roles'
    this.EXPIRES_AT_KEY = 'expiresAt'
    this.DISTRIBUTOR_KEY = 'distributor'
  }

  get token() {
    return localStorage.getItem(this.TOKEN_KEY)
  }

  set token(value) {
    localStorage.setItem(this.TOKEN_KEY, value)
  }

  get role() {
    return localStorage.getItem(this.ROLE_KEY)
  }

  set role(value) {
    localStorage.setItem(this.ROLE_KEY, value)
  }

  get fullName() {
    return localStorage.getItem(this.FULLNAME_KEY)
  }

  set fullName(value) {
    localStorage.setItem(this.FULLNAME_KEY, value)
  }

  get menu() {
    const menuStr = localStorage.getItem(this.MENU_KEY)
    return menuStr ? JSON.parse(menuStr) : []
  }

  set menu(value) {
    localStorage.setItem(this.MENU_KEY, JSON.stringify(value))
  }

  get roles() {
    const rolesStr = localStorage.getItem(this.ROLES_KEY)
    return rolesStr ? JSON.parse(rolesStr) : []
  }

  set roles(value) {
    localStorage.setItem(this.ROLES_KEY, JSON.stringify(value))
  }

  get distributor() {
    const v = localStorage.getItem(this.DISTRIBUTOR_KEY)
    return v ? JSON.parse(v) : null
  }

  set distributor(value) {
    if (value) {
      localStorage.setItem(this.DISTRIBUTOR_KEY, JSON.stringify(value))
    } else {
      localStorage.removeItem(this.DISTRIBUTOR_KEY)
    }
  }

  get expiresAt() {
    const v = localStorage.getItem(this.EXPIRES_AT_KEY)
    if (!v) return null
    const d = new Date(v)
    return isNaN(d.getTime()) ? null : d
  }

  set expiresAt(value) {
    if (value) {
      localStorage.setItem(this.EXPIRES_AT_KEY, value)
    } else {
      localStorage.removeItem(this.EXPIRES_AT_KEY)
    }
  }

  isExpired() {
    const exp = this.expiresAt
    if (!exp) return false
    return new Date().getTime() >= exp.getTime()
  }

  update(user) {
    localStorage.setItem(this.TOKEN_KEY, user.token)
    localStorage.setItem(this.ROLE_KEY, user.role)
    localStorage.setItem(this.FULLNAME_KEY, user.fullName)
    localStorage.setItem(this.MENU_KEY, JSON.stringify(user.menu || []))
    localStorage.setItem(this.ROLES_KEY, JSON.stringify(user.roles || []))
    if (user.distributor) {
      localStorage.setItem(
        this.DISTRIBUTOR_KEY,
        JSON.stringify(user.distributor)
      )
    } else {
      localStorage.removeItem(this.DISTRIBUTOR_KEY)
    }
    if (user.expiresAt) {
      localStorage.setItem(this.EXPIRES_AT_KEY, user.expiresAt)
    } else {
      localStorage.removeItem(this.EXPIRES_AT_KEY)
    }
  }

  clear() {
    localStorage.removeItem(this.TOKEN_KEY)
    localStorage.removeItem(this.ROLE_KEY)
    localStorage.removeItem(this.FULLNAME_KEY)
    localStorage.removeItem(this.MENU_KEY)
    localStorage.removeItem(this.ROLES_KEY)
    localStorage.removeItem(this.EXPIRES_AT_KEY)
    localStorage.removeItem(this.DISTRIBUTOR_KEY)
  }
}
export default new SessionHelper()
